import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/Gov-body.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import "../../Placement.css";
import mom from "../../Images/Ordinances andStatute/MOM of GB meeting 25112022.pdf";

// const governingBodyMembers = [
//     {
//         sr: 1,
//         name: "Dr. Vinay Agrawal",
//         designation: "Chairman",
//         remarks: "Chancellor, ISBM University",
//     },
//     {
//         sr: 2,
//         name: "Prof.(Dr) Anand Mahalwar",
//         designation: "Member",
//         remarks: "Vice Chancellor, ISBM University",
//     },
//     {
//         sr: 3,
//         name: "Mrs. Pramila Mahesh Agrawal",
//         designation: "Member",
//         remarks: "Nominee, Sponsoring Body, ISBM University",
//     },
//     {
//         sr: 4,
//         name: "Shri Mahesh Ratanlal Agrawal",
//         designation: "Member",
//         remarks: "Nominee, Sponsoring Body, ISBM University",
//     },
//     {
//         sr: 5,
//         name: "Shri Yashwanth Raj Parasmal",
//         designation: "Member",
//         remarks: "Nominee, Sponsoring Body, ISBM University",
//     },
//     {
//         sr: 6,
//         name: "Dr. Sarita Sinha",
//         designation: "Member",
//         remarks: "Principal (Retd.), Govt. Mata Karma Girls College, Mahasamund (CG)",
//     },
//     {
//         sr: 7,
//         name: "Dr. Madan Lal Lakhanpal",
//         designation: "Member",
//         remarks: "Principal (Retd.), Govt. Danteshwari Girls PG College, Jagdalpur (CG)",
//     },
//     {
//         sr: 8,
//         name: "Dr. Sheela Tiwari",
//         designation: "Member",
//         remarks: "Principal (Retd.), Govt. PG College, Bilaspur (CG)",
//     },
//     {
//         sr: 9,
//         name: "Dr. Barada Prasad Bhol",
//         designation: "Member Secretary",
//         remarks: "Registrar, ISBM University",
//     },
// ];

const pedagogyItems = [
  {
    icon: "📝",
    title: "Review",
    description:
      "To review, suggest, and approve policies, plans, procedures, and measures for the University's development from time to time.",
  },
  {
    icon: "📝",
    title: "Recommendations",
    description:
      "To make recommendations to the Chancellor/Sponsoring Body regarding different strategies.",
  },
  {
    icon: "📝",
    title: "Sponsoring Body",
    description:
      "To make recommendations to the Sponsoring Body for the creation of new officers, teachers, and staff of the University.",
  },
  {
    icon: "📝",
    title: "Exercise",
    description:
      "To exercise such other powers and functions as may be assigned by the Sponsoring Body.",
  },
  {
    icon: "📝",
    title: "Approve ",
    description:
      "To consider and approve the recommendations made by the Board of Management, Academic Council, Chancellor, and Vice Chancellor of the University.",
  },
  {
    icon: "📝",
    title: "3 times in a calendar year",
    description:
      "The Governing Body shall meet at least 3 times in a calendar year.",
  },
  {
    icon: "📝",
    title: "5 members",
    description:
      "The Governing Body shall maintain a quorum of 5 members as per section 22(5) of the Act.",
  },
];

const body = [
  {
    name: "Dr. Vinay Agrawal",
    designation: "Chairman",
    remarks: "Chancellor ISBM University",
  },
  {
    name: "Prof.(Dr) Anand Mahalwar",
    designation: "Member",
    remarks: "Vice Chancellor ISBM University",
  },
  {
    name: "Mrs. Pramila Mahesh Agrawal",
    designation: "Member",
    remarks: "Nominee, Sponsoring Body, ISBM University",
  },
  {
    name: "Shri Mahesh Ratanlal Agrawal",
    designation: "Member",
    remarks: "Nominee, Sponsoring Body, ISBM University",
  },
  {
    name: "Shri Yashwanth Raj Parasmal",
    designation: "Member",
    remarks: "Nominee, Sponsoring Body, ISBM University",
  },
  {
    name: "Dr. Sarita Sinha",
    designation: "Member",
    remarks:
      "Principal (Retd.), Govt. Mata Karma Girls College, Mahasamund (CG)",
  },
  {
    name: "Dr. Madan Lal Lakhanpal",
    designation: "Member",
    remarks:
      "Principal (Retd.), Govt. Danteshwari Girls PG College, Jagdalpur (CG)",
  },
  {
    name: "Dr. Sheela Tiwari",
    designation: "Member",
    remarks: "Principal (Retd.), Govt. PG College, Bilaspur (CG)",
  },
  {
    name: "Dr. Barada Prasad Bhol",
    designation: "Member Secretary",
    remarks: "Registrar, ISBM University",
  },
];

const GoverningBody = () => {
  return (
    <>
      <title>Governing Body – ISBM University | Leadership & Governance.</title>
      <meta
        name="description"
        content="Discover the Governing Body of ISBM University, driving academic excellence, strategic growth, and institutional leadership for a brighter future."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>Governing Body the Decision Making Authority</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Governing Body
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-light">
        <div className="container-xxl ptb-50">
          <Row className="m-0">
            <div className="col-md-6">
              <h2 className="modern-title text-blue">Governing Body</h2>
              <div className="underline-divider mb-3"></div>
              <p className="text-muted">
                The Governing Body is the apex decision-making authority
                responsible for guiding ISBM University's strategic vision and
                ensuring academic excellence. It monitors, evaluates, and
                recommends policies related to academic programs, human
                resources, and institutional development.
              </p>
              <p className="text-muted">
                This esteemed body comprises distinguished academicians,
                institutional leaders, and representatives from the sponsoring
                and state bodies. Their collective experience and insight guide
                the University in making impactful decisions related to
                curriculum development, infrastructure, policy formulation, and
                faculty recruitment.
              </p>
            </div>
            <div className="col-md-6">
              <div className="governing-image-wrapper shadow">
                <img src={classroomImage} alt="Governing Body" />
              </div>
            </div>
          </Row>
        </div>
      </section>

      <section className="container-xxl ptb-50">
        <h2 className="text-center modern-title text-blue">
          Powers and Functions of the Governing Body
        </h2>
        <div className="underline-center mb-5"></div>
        <div className="row m-0">
          {pedagogyItems.map((item, index) => (
            <div className="col-md-6 col-lg-4 mb-4" key={index}>
              <div className="d-flex h-100 border-end border-sm-0 pe-3">
                <div className="me-3 fs-1 text-secondary">{item.icon}</div>
                <div>
                  <h6 className="fw-bold mb-2 text-dark">{item.title}</h6>
                  <p className="text-muted small mb-0">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center fw-bold mb-3">Members</h2>
                    <div className="underline-center mb-5"></div>
                    <div className="row m-0">
                        <div className="col-lg-6 d-flex">
                            <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                <h4 className="fw-bold mb-3">
                                    Member of the Governing Body
                                </h4>
                                <div className="underlinetwo mb-4"></div>

                                <div className="visahead">
                                    <h5 className="text-dark">
                                        Dr. Vinay Agrawal
                                    </h5>
                                </div>
                                <ul>
                                    <li>Chairman</li>
                                    <li>Chancellor ISBM University</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Prof.(Dr) Anand Mahalwar
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Vice Chancellor ISBM University</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Mrs. Pramila Mahesh Agrawal
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Nominee, Sponsoring Body, ISBM University</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Shri Mahesh Ratanlal Agrawal
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Nominee, Sponsoring Body, ISBM University   </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-6 d-flex">
                            <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                <div className="visahead">
                                    <h5 className="text-dark">
                                        Shri Yashwanth Raj Parasmal
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Nominee, Sponsoring Body, ISBM University</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Dr. Sarita Sinha
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Principal (Retd.) Govt. Mata Karma Girls College, Mahasamund (CG). Nominee & Representative of State Govt.</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Dr. Madan Lal Lakhanpal
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Principal (Retd.) Govt. Danteshwari Girls Postgraduate College, Jagdalpur (CG). Nominee & Representative of State Govt.</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Dr. Sheela Tiwari
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Principle (Retd.) Govt. P.G. College, Bilashpur (CG). Nominee & Representative of State Govt.</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Dr. Barada Prasad Bhol
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member Secretary</li>
                                    <li>Registrar, ISBM University</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

      <section className="visa-section py-5 bg-light">
        <div className="container-xxl">
          <h2 className="text-center modern-title text-blue">Member of the Governing Body</h2>
          <div className="underline-center mb-5 mx-auto"></div>
          <div className="row m-0">
            {body.map((member, index) => (
              <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                  <div className="visahead">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5 className="text-dark mb-0">{member.name}</h5>
                      <span className="badge designation ms-2 ">
                        {member.designation}
                      </span>
                    </div>
                    <div className="underlinetwo"></div>
                  </div>
                  <ul className="mb-0 list-unstyled">
                    <li>{member.remarks}</li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="meeting">
        <div className="edu_letter_main_wrapper container-xxl">
          <div className="container-xxl">
            <div className="row p-4 ">
              {/* Left Side Text */}
              <div className="col-md-6 d-flex flex-column justify-content-center">
                <h3 className="text-white fw-bold m-0">
                  MOM of Governing Body meeting
                </h3>
              </div>

              {/* Right Side Button */}
              <div className="col-md-6 text-md-end text-center">
                <div className="d-flex flex-column align-items-md-end gap-3">
                  <a
                    href={mom}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn download border fw-bold px-5 p-2"
                  >
                    Download MOM
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default GoverningBody;
